// extracted by mini-css-extract-plugin
module.exports = {"fixedRegisterBanner":"style_fixedRegisterBanner__1fFxl"};